export default __webpack_public_path__ + "static/media/15.5ed44557.jpg";